import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from "./shared/components/loader/loader.component";
import { CommonModule } from '@angular/common';
import { LoaderService } from './shared/components/loader/loader.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoaderComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'dashboard-ui';
  isLoading = false;

  constructor( 
    private loaderService: LoaderService,
    private cdr: ChangeDetectorRef
   ){}
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.loaderService.loading$.subscribe(value => {this.isLoading = value;
      this.cdr.detectChanges(); 
   } );
  }
}

